import * as htmlparser2 from 'htmlparser2';
import * as entities from 'entities';
import { DomNode } from '@/types/common';

const ignoreTags = ['style', 'script', 'meta', 'link'];

export function getText(nodes: DomNode[]) {
  const texts: string[] = [];
  function loop(doms: DomNode[]) {
    if (!doms || !doms.length) {
      return;
    }
    doms.forEach((node: DomNode) => {
      if (!node) {
        return;
      }
      // ignore tags
      if (ignoreTags.find(tag => tag === node.name)) {
        return;
      }
      if (node.type === 'text') {
        texts.push(entities.decodeHTML(node.data || ''));
        return;
      }
      if (node.children) {
        loop(node.children);
      }
    });
  }
  loop(nodes);
  return texts.join('');
}

function parseHtml(html: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const handler = new htmlparser2.DomHandler(function(err, nodes) {
      if (err) {
        reject(err);
        return;
      }
      const text = getText(nodes as unknown as DomNode[]);
      resolve(text);
    });
    const parser = new htmlparser2.Parser(handler);
    parser.write(html);
    parser.done();
  });
}

export default { parseHtml };
